import React, { useState, useEffect } from 'react'

var JSONbig = require('json-bigint')({ useNativeBigInt: true })

const fetchwithtoken = (url = '', body = null, token = null, method) => {
  const auth = `Bearer ${token}`
  let options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
    },
  }
  options.method = method
  options.headers.Authorization = auth
  if (body !== null) {
    options.body = JSONbig.stringify(body)
  }
  return fetch(url, options)
}

export default fetchwithtoken
